/* One icon family for every section — the same `blocks/color` set the page builder's Add block
   modal uses. Half of these used to be flat line icons from @assets root, so the picker mixed
   two styles; Products and Videos also both showed the banner icon. */
import IconSectionImage from '@assets/blocks/color/banner.svg';
import IconSectionBlog from '@assets/blocks/color/blog.svg';
import IconSectionDiscount from '@assets/blocks/color/coupon.svg';
import IconSectionDigital from '@assets/blocks/color/digital.svg';
import IconSectionFeatures from '@assets/blocks/color/feature.svg';
import IconSectionFooter from '@assets/blocks/color/footer.svg';
import IconSectionGallery from '@assets/blocks/color/gallery.svg';
import IconSectionHeader from '@assets/blocks/color/header.svg';
import IconSectionHtml from '@assets/blocks/color/htmlCode.svg';
import IconSectionLinks from '@assets/blocks/color/links.svg';
import IconSectionReview from '@assets/blocks/color/review.svg';
import IconSectionSpacer from '@assets/blocks/color/spacer.svg';
import IconSectionBackground from '@assets/blocks/color/splashScreen.svg';
import IconSectionText from '@assets/blocks/color/text.svg';
import IconSectionTimer from '@assets/blocks/color/timer.svg';
import IconSectionVideo from '@assets/blocks/color/video.svg';
import IconSectionSocial from '@assets/blocks/color/wall.svg';
import IconSectionButton from '@assets/blocks/links/ctaType.svg';

import { homePath } from './constants.js';

export const mainMenuData = [
  {
    name: 'Broadcasts',
    path: `${homePath}`,
  },
  {
    name: 'Automations',
    path: `${homePath}/automations`,
  },
  {
    name: 'Templates',
    path: `${homePath}/emails`,
  },
  {
    name: 'Transactional',
    path: `${homePath}/transactional`,
  },
  {
    name: 'Settings',
    path: `${homePath}/settings`,
  },
];

export const contentMenuData = [
  {
    name: 'Content',
    type: `content`,
  },
  {
    name: 'Design',
    type: 'design',
  },
];

export const emailTypes = {
  broadcast: 'broadcast',
  workflow: 'workflow',
};

export const addSectionData = [
  {
    type: 'text',
    title: 'Text',
    text: 'Share basic content',
    icon: IconSectionText,
  },
  {
    type: 'image',
    title: 'Image',
    text: 'Share images',
    icon: IconSectionImage,
  },
  {
    type: 'header',
    title: 'Header',
    text: 'Share headers',
    icon: IconSectionHeader,
  },
  {
    type: 'button',
    title: 'Button',
    text: 'Share buttons',
    icon: IconSectionButton,
  },
  {
    type: 'link',
    title: 'Links',
    text: 'Share links',
    icon: IconSectionLinks,
  },
  {
    type: 'digital',
    title: 'Products',
    text: 'Showcase products from your shop',
    icon: IconSectionDigital,
  },
  {
    type: 'video',
    title: 'Videos',
    text: 'Add links to your videos',
    icon: IconSectionVideo,
  },
  {
    type: 'features',
    title: 'Features',
    text: 'List key features with icons',
    icon: IconSectionFeatures,
  },
  {
    type: 'gallery',
    title: 'Gallery',
    text: 'Show a grid of images',
    icon: IconSectionGallery,
  },
  {
    type: 'review',
    title: 'Reviews',
    text: 'Share testimonials and reviews',
    icon: IconSectionReview,
  },
  {
    type: 'blog',
    title: 'Blog posts',
    text: 'Link your latest articles',
    icon: IconSectionBlog,
  },
  {
    type: 'discount',
    title: 'Discount',
    text: 'Show a promo / coupon code',
    icon: IconSectionDiscount,
  },
  {
    type: 'timer',
    title: 'Countdown',
    text: 'Add an offer end date',
    icon: IconSectionTimer,
  },
  {
    type: 'social',
    title: 'Social links',
    text: 'Row of links to your profiles',
    icon: IconSectionSocial,
  },
  {
    type: 'spacer',
    title: 'Spacer',
    text: 'Add space or a divider line',
    icon: IconSectionSpacer,
  },
  {
    type: 'html',
    title: 'HTML',
    text: 'Drop in your own markup',
    icon: IconSectionHtml,
  },
  {
    type: 'background',
    title: 'Background',
    text: 'Add a visual background section',
    icon: IconSectionBackground,
    automationOnly: true,
  },
];

export const footerSectionData = {
  type: 'footer',
  title: 'Footer',
  text: 'Footer of your email',
  icon: IconSectionFooter,
};

export const sectionType = {
  text: 'text',
  image: 'image',
  header: 'header',
  button: 'button',
  link: 'link',
  digital: 'digital',
  video: 'video',
  spacer: 'spacer',
  background: 'background',
  footer: 'footer',
  social: 'social',
  html: 'html',

  // Link-backed variants (editor routing only; Core section type stays 'link')
  features: 'features',
  gallery: 'gallery',
  review: 'review',
  blog: 'blog',
  discount: 'discount',
  timer: 'timer',
};

export const listHeaderData = [
  {
    name: 'Broadcast',
    width: '32%',
  },
  {
    name: 'Status',
    width: '13%',
  },
  {
    name: 'Recipients',
    width: '12%',
  },
  {
    name: 'Open rate',
    width: '18%',
  },
  {
    name: 'Click rate',
    width: '18%',
  },
  {
    name: 'Actions',
    width: '7%',
  },
];

export const emailTemplatesHeaderData = [
  {
    name: 'Email',
    width: '55%',
  },
  {
    name: 'Type',
    width: '19%',
  },
  {
    name: 'Status',
    width: '20%',
  },
  {
    name: 'Actions',
    width: '6%',
  },
];

export const contentMenuTypes = {
  content: 'content',
  design: 'design',
};

export const layoutTypes = {
  full: 'full',
  card: 'card',
};

export const sectionHeaderTypes = {
  Image: 'Image',
  ImageShape: 'ImageShape',
  ImageSize: 'ImageSize',
  ImageHyperlink: 'ImageHyperlink',
  Text: 'Text',
  View: 'View',
};
